const anchor = 0.5;
export const webGameConfigs = {
  width: 1440,
  height: 810,
  cullable: true,
  antialias: false,
  backgroundAlpha: 0,
  useContextAlpha: false,
  SlotBarContainer: {
    slotBarReelsContainerConfig: { x: 95, y: 194.5 },
    slotBarReelContainer: { x: -636.5, y: -193 },
    lineContainer: { x: 0, y: 0 },
  },
  WinBarContainer: {
    winLineConfig: { x: -26, y: 0 },
    winningLineConfig: { x: 281, y: 380 },
    winCoinsConfig: { x: 748, y: 460, scale: 0.7 },
    winLineAmountConfig: { x: 0, y: 0, anchor: anchor },
  },
  IntroBarContainer: {
    soundTextConfig: { y: -65 },
    symbolPayout: { x: 0, y: 0 },
    divisionLineConfig: { y: -65 },
    switcherConfig: { x: 455, y: -65 },
    payTableLinesConfig: { x: 0, y: 0 },
    payTableStep3Text: { x: 586, y: 655 },
    payTableSymbolPayout: { x: 300, y: -280 },
    introBarContainerConfig: { x: 270, y: 0 },
    payTableBarContainerConfig: { x: 0, y: 0 },
    payTableStep1Container: { x: 0, y: 0 },
    payTableStep1ContainerText: { x: 586, y: 655 },
    payTableArrowContainer: { x: 438, y: 720 },
    progressControllerConfig: { x: -188, y: -4 },
    settingsBarContainerConfig: { x: 302, y: 443 },
    settingsButtonsContainer: { x: 391, y: 444 },
    settingsHeaderContainerConfig: { x: 301, y: 444 },
    buttonsTitleConfig: { x: 190, y: -100, anchor },
    soundSettingsContainerConfig: { x: 32, y: -200 },
    payTableWildScene: { x: 0, y: 0, anchor: anchor },
    payTableStep4Text: { x: 586, y: 655, anchor: anchor },
    payTableJackpotScene: { x: 0, y: 0, anchor: anchor },
    settingsTitleConfig: { x: 290, y: -400, anchor: anchor },
    payTableStep5Text: { x: 586, y: 665, anchor: anchor },
    payOutWildContainerConfig: { x: 245, y: -120, anchor: anchor },
    payOutSymbolsContainerConfig: { x: 50, y: 90, anchor: anchor },
    fastAndSlowContainerConfig: { x: 292, y: -135, anchor: anchor },
    gameRulesContainerConfig: { x: 0, y: 0, anchor: anchor },
    payTableOddAndAmountInfoConfig: { x: 20, y: 273 },
  },
  SlotBoardContainer: {
    x: 250,
    y: 130,
    gameLogoConfig: { x: 482, y: -38 },
    gameBoardConfig: { x: 480.5, y: 253.5 },
    bigMobileLogo: { x: 295, y: -125 },
  },
  TournamentIcon: {
    x: 1100,
    y: 30,
    anchor: anchor,
  },
  ConnectionPopupContainer: {
    reconnectIcon: { x: 739.5, y: 280, anchor: anchor },
    popupInfoText: { x: 739.5, y: 345, anchor: anchor },
    popupOkButton: { x: 739.5, y: 420, anchor: anchor },
    popupOkButtonText: { x: 739, y: 430, anchor: anchor },
    connectionPopupConfig: { x: 729, y: 350, anchor: anchor },
  },
  NotificationContainer: {
    maintenance: { x: 1201, y: 107, anchor },
    notification: { x: 1250, y: 107, anchor },
    maintenanceImg: { x: 982, y: 107, anchor },
    notificationImg: { x: 1097, y: 108, anchor },
    maintenanceText: { x: 1220, y: 107, anchor },
    notificationText: { x: 1266, y: 107, anchor },
  },
  MenuBarContainer: {
    homeTextConfig: { x: 117, y: 352 },
    payTableTextConfig: { x: 25, y: 0 },
    menuBarYellowLayer: { x: 136, y: 331 },
    // rulesTextConfig: { x: 100, y: 138 },
    rulesTextConfig: { x: 85, y: 70 },
    historyTextConfig: { x: 36, y: 197 },
    // settingsTextConfig: { x: 85, y: 70 },
    graphicsContainerMask: { x: 0, y: 0 },
    menuBarPopupConfig: { x: 0, scale: 0.5 },
    menuBarPopupContainerConfig: { x: 0, y: 0 },
    iconsAndTextContainerConfig: { x: 46, y: 331 },
    menuBarWrapperContainerConfig: { x: 25, y: 770 },
    homeButtonConfig: { x: 0, y: 0, anchor: anchor },
    // rulesIconConfig: { y: 140, anchor: anchor, scale: 0.5 },
    rulesIconConfig: { y: 70, anchor: anchor, scale: 0.5 },
    soundControllerConfig: { x: 50, y: -50, anchor: anchor },
    // settingsIconConfig: { y: 70, anchor: anchor, scale: 0.5 },
    historyIconConfig: { y: 210, anchor: anchor, scale: 0.5 },
    menuWrapperShadowConfig: { x: 455, y: 33, anchor: anchor },
    menuGameLogo: { x: 135, y: 96, anchor: anchor },
    soundControllerLineConfig: { x: 50, y: -75, anchor: anchor },
    payTableIconConfig: { x: 50, y: 0, anchor: anchor, scale: 0.5 },
    dateContainerConfig: { x: 1312, y: 11, anchor: anchor },
    dateTextConfig: { x: 18, anchor: anchor },
    timeIconConfig: { y: 3 },
    soundControllerLineFillGraphics: { x: 50, y: -5, anchor: anchor },
  },
  BetBarContainer: {
    betBarContainerConfig: { x: 538, y: 650 },
    betButtonContainerConfig: { x: 0, y: 66 },
    betBarArrowsContainerConfig: { x: 0, y: 66 },
    soundIconConfig: { x: 50, y: 13, anchor: anchor },
    currencyConfig: { x: -27, y: -15, anchor: anchor },
    winAndLastWinContainerConfig: { x: 189, y: 123 },
    openMenuIconConfig: { x: 3, y: 13, anchor: anchor },
    balanceTextConfig: { x: 170, y: 15, anchor: anchor },
    winCurrencyConfig: { x: 133, y: -10, anchor: anchor },
    menuBarWrapperConfig: { x: -25, y: 0, anchor: anchor },
    fullScreenIconConfig: { x: 98, y: 13, anchor: anchor },
    balanceAmountConfig: { x: 250, y: 5, anchor: 0 },
    winAndLastWinTextConfig: { x: 0, y: 0, anchor: anchor },
    currencyCode: { x: 0, y: 0, anchor: anchor },
    normalBetButtonsConfig: { x: -28, y: 0, anchor: anchor },
    betButtonsAmountConfig: { x: -27, y: 7, anchor: anchor },
    winAndLastWinAmountConfig: { x: 0, y: -1, anchor: anchor },
    betButtonArrowLeftConfig: { x: -110, y: 0, anchor: anchor },
    betButtonArrowRightConfig: { x: 490, y: 0, anchor: anchor },
    closeFullScreenIconConfig: { x: -60, y: -20, anchor: anchor },
    closeMenuBarIconConfig: { x: -140, y: -20, anchor: anchor, scale: 1 },
  },
  SpinBarContainer: {
    fastSpinButtonConfig: { x: -78, y: 50 },
    spinBarContainerConfig: { x: 1150, y: 725 },
    spinButtonConfig: { x: 90, y: 0, anchor: anchor },
    infinityIconConfig: { x: 190, y: -100, anchor: anchor },
    autoBetButtonConfig: { x: 190, y: -50, anchor: anchor },
    slowSpinButtonConfig: { x: -40, y: 50, anchor: anchor },
    spinButtonArrowsConfig: { x: 90, y: 0, anchor: anchor },
    autoBetCountsConfig: { x: 190, y: -275, anchor: anchor },
    autoBetStopButtonConfig: { x: 200, y: 7.5, anchor: anchor },
    selectedAutoBetCountConfig: { x: 190, y: -50, anchor: anchor },
    autoBetEnableButtonConfig: { x: 200, y: 10, anchor: anchor },
    autoBetCountsPopupConfig: { x: 190, y: -188, anchor: anchor },
    gambleStartButtonContainerConfig: { x: -10, y: 50, anchor: anchor },
  },
  LineWinBarContainer: { x: 281, y: 560 },
  ExpandWildBarContainer: { x: 370, y: 194 },
  FreeBetPopupContainerConfig: {
    freeBetPopupContainer: { x: 385, y: 85, scale: 0.9 },
    freeBetButtonContainer: { x: 240, y: 510 },
    freeBetCountHeader: { x: 735, y: 765, anchor: anchor },
    freeBetTotalWinHeader: { x: 380, y: 320, anchor: anchor },
    freeBetWinAmountConfig: { x: 390, y: 420, anchor: anchor },
  },
  WinPopupContainer: {
    winPopupConfig: { x: 728, y: 370 },
  },
  JackpotContainer: {
    activeColumnConfig: { x: 726.5, y: 398 },
    jackpotStartPopup: { x: 709.5, y: 406 },
    jackpotGameSceneBoard: { x: 720, y: 405 },
    jackpotSymbolsBg: { x: 501, y: 170 },
    jackpotHeartAmountBoard: { x: 170.5, y: 228.5 },
    jackpotSpadesAmountBoard: { x: 1278.5, y: 228.5 },
    jackpotClubsAmountBoard: { x: 296.5, y: 424 },
    jackpotDimondAmountBoard: { x: 1151, y: 424 },
    jackpotWinPopupAnimation: { x: 719.5, y: 403.5 },
    jackpotSceneTextureContainers: { x: 570, y: 233 },
    jackpotAmountSymbols: [0, 46.5, 112.5],
    expiresDateContainerConfig: { x: 655, y: 129.5 },
    jackpotSymbolsContainerPositionList: [
      {
        id: 1,
        x: 0,
        y: 0,
      },
      {
        id: 2,
        x: 142,
        y: 0,
      },
      {
        id: 3,
        x: 283.5,
        y: 0,
      },
      {
        id: 4,
        x: 0,
        y: 143,
      },
      {
        id: 5,
        x: 142,
        y: 143,
      },
      {
        id: 6,
        x: 283.5,
        y: 143,
      },
      {
        id: 7,
        x: 0,
        y: 286,
      },
      {
        id: 8,
        x: 142,
        y: 286,
      },
      {
        id: 9,
        x: 283.5,
        y: 286,
      },
      {
        id: 10,
        x: 0,
        y: 429,
      },
      {
        id: 11,
        x: 142,
        y: 429,
      },
      {
        id: 12,
        x: 283.5,
        y: 429,
      },
    ],
    heartSymbolContainer: { x: 87, y: 135.5 },
    clubsSymbolContainer: { x: 216, y: 322.5 },
    spadesSymbolContainer: { x: 1200.5, y: 136.5 },
    diamondSymbolContainer: { x: 1076.5, y: 327.5 },
  },
  GambleContainer: {
    backgroundConfig: { x: 728, y: 383.5, anchor: anchor },
    historyContainerConfig: { x: 731, y: 160 },
    historyTitleConfig: { x: 0, y: 0, anchor: anchor },
    historyRedCardConfig: { x: 0, y: 70, anchor: anchor },
    winAmountConfig: { x: 0, y: 60, anchor: 1 },
    amountsContainerConfig: { x: 460, y: 335 },
    winAmountFrameConfig: { y: 60, anchor: anchor },
    winAmountCurrencyConfig: { x: 0, y: 38, anchor: 0 },
    gambleToWinAmountConfig: { x: 0, y: 60, anchor: 1 },
    gambleToWinAmountFrameConfig: { y: 50 },
    gambleToWinAmountContainer: { x: 535 },
    gambleToWinAmountCurrencyConfig: { x: 0, y: 38, anchor: 0 },
    redButtonContainerConfig: { y: 90 },
    blackButtonContainerConfig: { x: 460, y: 90 },
    gambleMainContainerConfig: { x: 500, y: 435 },
    flipCardConfig: { x: 228 },
    attemptsLftContainerConfig: { x: 820, y: 605 },
    attemptsLeftCountConfig: { x: 10 },
    collectContainerConfig: { x: 1236, y: 712, anchor: anchor },
    youWinConfig: { x: 228, y: 0, anchor: anchor },
  },
  get applicationConfigs() {
    return {
      width: this.width,
      height: this.height,
      backgroundAlpha: this.backgroundAlpha,
    };
  },
};

export const mobileGameConfigs = {
  width: 540,
  height: 960,
  cullable: true,
  antialias: false,
  backgroundAlpha: 1,
  useContextAlpha: false,
  SlotBarContainer: {
    slotBarReelsContainerConfig: { x: 61, y: 294 },
    slotBarReelContainer: { x: -209, y: -112 },
    lineContainer: { x: -273, y: 25 },
  },
  WinBarContainer: {
    winLineConfig: { x: 0, y: 0 },
    winningLineConfig: { x: 281, y: 380 },
    winCoinsConfig: { x: 268, y: 442, scale: 0.5 },
    winLineAmountConfig: { x: 0, y: 0, anchor: anchor },
    expandingWildReelsContainerConfig: { x: -38 },
  },
  IntroBarContainer: {
    soundTextConfig: { y: -65 },
    divisionLineConfig: { y: -65 },
    symbolPayout: { x: 0, y: 90 },
    switcherConfig: { x: 437, y: -65 },
    buttonsTitleConfig: { x: 190, y: -100 },
    payTableSymbolPayout: { x: 400, y: -200 },
    payTableStep3Text: { x: 272, y: 660 },
    introBarContainerConfig: { x: 0, y: 0 },
    payTableStep1Container: { x: 0, y: 240 },
    payTableStep1ContainerText: { x: 272, y: 640 },
    payTableArrowContainer: { x: 132.5, y: 777.5 },
    progressControllerConfig: { x: -188, y: -4 },
    settingsBarContainerConfig: { x: 6.5, y: 642.5 },
    settingsButtonsContainer: { x: 84, y: 615 },
    settingsHeaderContainerConfig: { x: 11, y: 697 },
    payTableBarContainerConfig: { x: 0, y: 0 },
    soundSettingsContainerConfig: { x: 0, y: -200 },
    payTableWildScene: { x: 0, y: 90, anchor: anchor },
    payTableStep4Text: { x: 272, y: 640, anchor: anchor },
    payTableJackpotScene: { x: 0, y: 90, anchor: anchor },
    settingsTitleConfig: { x: 258, y: -359, anchor: anchor },
    payTableStep5Text: { x: 272, y: 640, anchor: anchor },
    payTableLinesConfig: { x: 0, y: 90 },
    payOutWildContainerConfig: { x: 245, y: -120, anchor: anchor },
    payOutSymbolsContainerConfig: { x: 50, y: 90, anchor: anchor },
    fastAndSlowContainerConfig: { x: 292, y: -135, anchor: anchor },
    gameRulesContainerConfig: { x: -134, y: 235, anchor: anchor },
    payTableOddAndAmountInfoConfig: { x: 0, y: 0 },
  },
  SlotBoardContainer: {
    x: 8,
    y: 257,
    gameLogoConfig: { x: 264, y: -31 },
    bigMobileLogo: { x: 84, y: -176 },
    gameBoardConfig: { x: 262.5, y: 147.5 },
  },
  TournamentIcon: {
    x: 480,
    y: -60,
    anchor: anchor,
  },
  BackgroundContainer: {
    backgroundConfig: { x: 188, y: 333, anchor: anchor },
  },
  ConnectionPopupContainer: {
    connectionPopupConfig: { x: 267, y: 408, anchor: anchor },
    reconnectIcon: { x: 272, y: 342, anchor: anchor },
    popupInfoText: { x: 272, y: 395, anchor: anchor },
    popupOkButton: { x: 272, y: 463.5, anchor: anchor },
    popupOkButtonText: { x: 276, y: 530, anchor: anchor },
  },
  NotificationContainer: {
    maintenance: { x: 354, y: 262, anchor },
    notification: { x: 370, y: 247, anchor },
    maintenanceImg: { x: 205, y: 262, anchor },
    notificationImg: { x: 225, y: 247, anchor },
    maintenanceText: { x: 368, y: 261, anchor },
    notificationText: { x: 383, y: 247, anchor },
  },
  MenuBarContainer: {
    homeTextConfig: { x: 87, y: 171 },
    payTableTextConfig: { x: 85, y: 0 },
    menuBarYellowLayer: { x: 85, y: 331 },
    rulesTextConfig: { x: 100, y: 138 },
    historyTextConfig: { x: 36, y: 197 },
    settingsTextConfig: { x: 85, y: 70 },
    menuBarPopupConfig: { x: 0, scale: 0.5 },
    menuBarPopupContainerConfig: { x: -80, y: 0 },
    iconsAndTextContainerConfig: { x: 150, y: 400 },
    menuBarWrapperContainerConfig: { x: 60, y: 924 },
    homeButtonConfig: { x: 70, y: 171, anchor: anchor },
    rulesIconConfig: { y: 140, anchor: anchor, scale: 0.5 },
    soundControllerConfig: { x: 381, y: -28, anchor: anchor },
    settingsIconConfig: { y: 70, anchor: anchor, scale: 0.5 },
    historyIconConfig: { y: 210, anchor: anchor, scale: 0.5 },
    menuWrapperShadowConfig: { x: 220, y: 12, anchor: anchor },
    menuGameLogo: { x: 279, y: 96.5, anchor: anchor },
    soundControllerLineConfig: { x: 381, y: -83, anchor: anchor },
    payTableIconConfig: { x: 50, y: 0, anchor: anchor, scale: 0.5 },
    settingsButtonsContainer: { x: 77, y: 0 },
    logoWrapperContainer: { x: 174, y: 23 },
    graphicsContainerMask: { x: 381.5, y: 32 },
    settingsIconsWrapper: { x: 101, y: 903 },
    closeMenuBarIcon: { x: 496, y: 149 },
    soundControllerLineFillGraphics: { x: 50, y: 59, anchor: anchor },
    dateContainerConfig: { x: 0, y: 0, anchor: anchor },
    timeIconConfig: { y: 3 },
    dateTextConfig: { x: 18, anchor: anchor },
  },
  BetBarContainer: {
    freeSpinLeftConfig: { x: 0, y: 0 },
    betBarContainerConfig: { x: 0, y: 624 },
    betButtonContainerConfig: { x: 87, y: 0 },
    betBarArrowsContainerConfig: { x: 0, y: 0 },
    winAndLastWinContainerConfig: { x: 268, y: 40 },
    currencyConfig: { x: 0, y: -12, anchor: anchor },
    soundIconConfig: { x: 381, y: 0, anchor: anchor },
    balanceTextConfig: { x: 7, y: 10, anchor: anchor },
    winCurrencyConfig: { x: 97, y: -4, anchor: anchor },
    menuBarWrapperConfig: { x: -70, y: 0, anchor: anchor },
    balanceAmountConfig: { x: 34, y: 0, anchor: 0 },
    normalBetButtonsConfig: { x: 0, y: 0, anchor: anchor },
    betButtonsAmountConfig: { x: 0, y: 7, anchor: anchor },
    openMenuIconConfig: { x: 435, y: 0, anchor: anchor },
    winAndLastWinTextConfig: { x: 0, y: 0, anchor: anchor },
    currencyCode: { x: 83, y: -22, anchor: anchor },
    fullScreenIconConfig: { x: -60, y: -20, anchor: anchor },
    betButtonArrowLeftConfig: { x: 21, y: 0, anchor: anchor },
    winAndLastWinAmountConfig: { x: 0, y: 0, anchor: anchor },
    betButtonArrowRightConfig: { x: 520, y: 0, anchor: anchor },
    closeFullScreenIconConfig: { x: -60, y: -20, anchor: anchor },
    freeSpinInfoContainerConfig: { x: 263, y: -48, anchor: anchor },
    closeMenuBarIconConfig: { x: -140, y: -20, anchor: anchor, scale: 0.8 },
  },
  JackpotContainer: {
    activeColumnConfig: { x: 270.5, y: 406.5 },
    jackpotStartPopup: { x: 270.5, y: 403.5 },
    jackpotGameSceneBoard: { x: 273, y: 484 },
    jackpotSymbolsBg: { x: 0, y: 0 },
    jackpotHeartAmountBoard: { x: 128, y: 167.5 },
    jackpotSpadesAmountBoard: { x: 417.5, y: 167.5 },
    jackpotClubsAmountBoard: { x: 164, y: 263.5 },
    jackpotDimondAmountBoard: { x: 377.5, y: 263.5 },
    jackpotWinPopupAnimation: { x: 267, y: 525.5 },
    jackpotSceneTextureContainers: { x: 131.5, y: 395 },
    jackpotAmountSymbols: [0, 34.5, 78.5],
    expiresDateContainerConfig: { x: 221, y: 109.5 },
    heartSymbolContainer: { x: 71.5, y: 119.5 },
    clubsSymbolContainer: { x: 107.5, y: 215.5 },
    spadesSymbolContainer: { x: 363.5, y: 119.5 },
    diamondSymbolContainer: { x: 321, y: 215.5 },
    jackpotSymbolsContainerPositionList: [
      {
        id: 1,
        x: 0,
        y: 0,
      },
      {
        id: 2,
        x: 142,
        y: 0,
      },
      {
        id: 3,
        x: 283.5,
        y: 0,
      },
      {
        id: 4,
        x: 0,
        y: 143,
      },
      {
        id: 5,
        x: 142,
        y: 143,
      },
      {
        id: 6,
        x: 283.5,
        y: 143,
      },
      {
        id: 7,
        x: 0,
        y: 286,
      },
      {
        id: 8,
        x: 142,
        y: 286,
      },
      {
        id: 9,
        x: 283.5,
        y: 286,
      },
      {
        id: 10,
        x: 0,
        y: 429,
      },
      {
        id: 11,
        x: 142,
        y: 429,
      },
      {
        id: 12,
        x: 283.5,
        y: 429,
      },
    ],
  },
  SpinBarContainer: {
    fastSpinButtonConfig: { x: -10, y: 80 },
    spinBarContainerConfig: { x: 216.5, y: 741 },
    gambleStartButtonContainerConfig: { x: -53, y: 92, anchor: anchor },
    spinButtonConfig: { x: 65, y: 40, anchor: anchor },
    autoBetButtonConfig: { x: 176, y: -11, anchor: anchor },
    slowSpinButtonConfig: { x: -83, y: 91.5, anchor: anchor },
    infinityIconConfig: { x: 175, y: -62, anchor: anchor },
    autoBetCountsConfig: { x: 175, y: -239, anchor: anchor },
    spinButtonArrowsConfig: { x: 65, y: 40, anchor: anchor },
    autoBetStopButtonConfig: { x: 200, y: 7.5, anchor: anchor },
    selectedAutoBetCountConfig: { x: 176, y: -11, anchor: anchor },
    autoBetEnableButtonConfig: { x: 200, y: 10, anchor: anchor },
    autoBetCountsPopupConfig: { x: 175, y: -148, anchor: anchor },
  },
  ExpandWildBarContainer: {
    x: 58,
    y: 294,
  },
  LineWinBarContainer: {
    x: 0,
    y: 307,
  },
  FreeBetPopupContainerConfig: {
    freeBetPopupContainer: {
      x: 40,
      y: 150,
      scale: 0.9,
    },
    freeBetButtonContainer: {
      x: 115,
      y: 300,
    },
    freeBetWinAmountConfig: { x: 255, y: 260, anchor: anchor },
    freeBetTotalWinHeader: { x: 255, y: 0, anchor: anchor },
    freeBetCountHeader: { x: 270, y: 566, anchor: anchor },
  },
  WinPopupContainer: {
    winPopupConfig: {
      x: 270,
      y: 409,
    },
  },
  GambleContainer: {
    backgroundConfig: { x: 271, y: 407, anchor: anchor },
    historyContainerConfig: { x: 272, y: 270 },
    historyTitleConfig: { x: 0, anchor: anchor },
    historyRedCardConfig: { y: 40, anchor: anchor },
    winAmountConfig: { x: 0, y: 38, anchor: 1 },
    amountsContainerConfig: { x: 118, y: 360 },
    winAmountFrameConfig: { y: 37, anchor: anchor },
    winAmountCurrencyConfig: { x: 0, y: 26, anchor: 0 },
    gambleToWinAmountConfig: { x: 0, y: 38, anchor: 1 },
    gambleToWinAmountFrameConfig: { y: 37 },
    gambleToWinAmountContainer: { x: 309 },
    gambleToWinAmountCurrencyConfig: { x: 0, y: 26, anchor: 0 },
    redButtonContainerConfig: { y: 110 },
    blackButtonContainerConfig: { x: 285, y: 110 },
    gambleMainContainerConfig: { x: 130, y: 371 },
    flipCardConfig: { x: 142 },
    attemptsLftContainerConfig: { x: 325, y: 532 },
    attemptsLeftTextConfig: { x: -8, y: 16, anchor: 1 },
    collectContainerConfig: { x: 280, y: 785, anchor: anchor },
    youWinConfig: { x: 142.5, y: 60, anchor: anchor },
    attemptsLeftCountConfig: { x: 5 },
  },

  get applicationConfigs() {
    return {
      width: this.width,
      height: this.height,
      backgroundColor: this.backgroundColor,
      backgroundAlpha: this.backgroundAlpha,
    };
  },
};
